import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import CheckIcon from '@material-ui/icons/Done';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import VirtualList from 'react-tiny-virtual-list';
import { getLesserBilledTransactions } from 'data/transactionList/selectors';
import AmountField from 'components/QuickenControls/AmountField';
import zeroStateIcon from 'assets/zero-state-images/safebox.svg';
import ZeroStateView from 'components/ZeroStateView';
import QButton from 'components/QButton';
import Avatar from '@material-ui/core/Avatar';


const styles = () => ({
  VL: {
    padding: '10px 10px',
    marginTop: 2,
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      width: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 3,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      WebkitBoxShadow: '0 0 1px rgba(245, 245, 245, 0.5)',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
      },
    },
  },
  txnLine: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 2,
    borderBottom: '1px solid #fafaf9',
    padding: '14px 24px',
    '&:hover': {
      boxShadow: '1px 1px 3px 0 rgba(0, 0, 0, 0.2)',
    },
  },
  txnLineShaded: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 2,
    borderBottom: '1px solid #fafaf9',
    padding: '14px 24px',
    boxShadow: '1px 1px 4px 1px rgba(0, 0, 0, 0.3)',
    '&:hover': {
      boxShadow: '1px 1px 4px 1px rgba(0, 0, 0, 0.4)',
    },
  },
  avatar: {
    marginRight: 24,
    borderRadius: 1,
    width: 24,
    height: 24,
  },
  dater: {
    paddingLeft: 10,
    width: '22%',
  },
  payer: {
    width: '30%',
    minWidth: 90,
  },
  amter: {
    width: '20%',
    paddingRight: '2%',
    textAlign: 'right',
    minWidth: 64,
  },
  checkWrap: {
    width: '10%',
    display: 'flex',
    justifyContent: 'center',
  },
  checkIcon: {
    backgroundColor: '#4caf50',
    borderRadius: '50%',
    color: '#fff',
    width: 24,
    height: 24,
    padding: 2,
  },
  noCheck: {
    backgroundColor: 'inherit',
    borderRadius: '50%',
    width: 24,
    height: 24,
    padding: 2,
    color: 'transparent',
    border: '1px solid #d8d8d8',
  },
  zeroState: {
    textAlign: 'center',
    lineHeight: 2,
  },
  stateView: {
    height: 320,
  },
  zeroRoot: {
    height: '80%',
  },
  zeroReset: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    height: 32,
  },
});

class ScheduledList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      displayNodes: [],
    };

  }

  generateTxns() {
    const { acctTxns, classes, clickFunc, highlight } = this.props;
    this.state.displayNodes = [];
    let i = 0;
    acctTxns.map((txn) => {
      this.state.displayNodes.push(
        <div
          role="presentation"
          key={i}
          name={`txn-item-${i}`}
          id={JSON.stringify(txn)}
          onClick={clickFunc}
          className={highlight === txn.id ? classes.txnLineShaded : classes.txnLine}
        >
          <Avatar className={classes.avatar}>
            {((txn || {}).payee || '')[0]}
          </Avatar>
          <Typography variant="body2" noWrap className={classes.dater}>
            {moment(txn.postedOn).format('MMM D, YYYY')}
          </Typography>
          <Typography variant="body2" noWrap className={classes.payer}>
            {txn.payee}
          </Typography>
          <AmountField
            optimisticSign
            color={txn.amount > 0 ? 'green' : undefined}
            value={txn.amount}
            variant="body2"
            className={classes.amter}
            noWrap
          />
          <div className={classes.checkWrap}>
            <CheckIcon className={highlight === txn.id ? classes.checkIcon : classes.noCheck}/>
          </div>
        </div>
      );
      i += 1;
      return '';
    });
  }

  render() {
    const { acctTxns, classes, onReset, filter, isBill } = this.props;
    if (!acctTxns.size) {
      return (filter ?
        <div className={classes.stateView}>
          <ZeroStateView
            icon={zeroStateIcon}
            primary="We couldn't find any transactions"
            secondary={
              <>
                You might have searched for something too specific.
                <br/>
                Try resetting the search
              </>
            }
            classes={{ secondary: classes.zeroState, root: classes.zeroRoot }}
          />
          <div className={classes.zeroReset}>
            <QButton onClick={onReset} variant="text">
              Click Here
            </QButton>
            <Typography style={{ color: '#666', lineHeight: '32px', marginLeft: 4 }}>
              to reset the search.
            </Typography>
          </div>
        </div>
        :
        <div className={classes.stateView}>
          <ZeroStateView
            icon={zeroStateIcon}
            primary={isBill === undefined ? `No Transactions` : `No ${isBill ? 'Bill' : 'Income'} Transactions`}
            secondary={
              <>
                {`Either your account doesn't have transactions,`}
                <br />
                {`or we've already created a schedule for them all.`}
              </>
            }
            classes={{ secondary: classes.zeroState, root: classes.zeroRoot }}
          />
        </div>
      );
    }
    if (acctTxns && this.state.displayNodes) {
      this.generateTxns();
    }
    return (
      acctTxns.size &&
        <VirtualList
          height={320}
          itemCount={this.state.displayNodes.length}
          overscanCount={30}
          itemSize={54}
          estimatedItemSize={54}
          renderItem={({ style, index }) => (this.state.displayNodes[index] ?
            <div style={style} key={index}>
              {this.state.displayNodes[index]}
            </div>
            : ''
          )}
          className={this.props.classes.VL}
        />
    );
  }
}

ScheduledList.propTypes = {
  classes: PropTypes.object.isRequired,
  acctTxns: PropTypes.any,
  clickFunc: PropTypes.func,
  highlight: PropTypes.string,
  onReset: PropTypes.func,
  filter: PropTypes.string,
  isBill: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    acctTxns: getLesserBilledTransactions(state, {
      accountIds: null,
      filter: ownProps.filter,
      isBill: ownProps.isBill,
    }),
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(ScheduledList);
